"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _baseColors = _interopRequireDefault(require("../baseColors"));

var _baseColors2 = _interopRequireDefault(require("./baseColors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var buttonedTabs = {
  selectedBorder: _baseColors["default"].denim,
  unselectedBorder: _baseColors2["default"].atomic,
  selectedBackground: _baseColors["default"].white,
  backgroundHover: _baseColors["default"].denim,
  backgroundActive: _baseColors["default"].denim,
  selectedText: _baseColors["default"].denim,
  unselectedText: _baseColors2["default"].black,
  textHover: _baseColors["default"].white
};
var _default = buttonedTabs;
exports["default"] = _default;